'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _os = require('os');

var _os2 = _interopRequireDefault(_os);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var EVERY_MINUTE = 60 * 1000;
  var mb = function mb(b) {
    return Math.round(b / 1024 / 1024);
  };
  var appStatus = function appStatus() {
    var _process$memoryUsage = process.memoryUsage(),
        rss = _process$memoryUsage.rss,
        heapTotal = _process$memoryUsage.heapTotal,
        heapUsed = _process$memoryUsage.heapUsed;

    console.info('MEMORY STATUS: rss: ' + mb(rss) + 'mb, heapTotal: ' + mb(heapTotal) + 'mb, heapUsed: ' + mb(heapUsed) + 'mb / OS FREE: ' + mb(_os2.default.freemem()) + 'mb TOTAL: ' + mb(_os2.default.totalmem()) + 'mb');
  };
  setInterval(appStatus, EVERY_MINUTE);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/utils/server-status.js
// module id = 579
// module chunks = 0